module.exports = __webpack_public_path__ + "static/media/feacbook.32bbd030.png";